module.exports = __webpack_public_path__ + "media/06.e03b2088.mp3";